import React, { useState, useEffect } from "react";
import fire from "./fire";
import LoginTable from "../../Components/LoginTable/LoginTable";
import { makeStyles } from "@material-ui/core";
import { useHistory } from "react-router-dom";
export default function LoginPage() {
  let history = useHistory();
  const useStyles = makeStyles({
    loginPage: {
      margin: 0,
      position: "absolute",
      top: "50%",
      left: "50%",
      msTransform: "translate(-50%, -50%)",
      transform: "translate(-50%, -50%)",
    },
  });
  const [user, setUser] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [hasAccount, setHasAccount] = useState(false);
  function clearInputs() {
    setEmail("");
    setPassword("");
  }

  function clearErrors() {
    setEmailError("");
    setPasswordError("");
  }
  function handleLogin() {
    clearErrors();
    fire
      .auth()
      .signInWithEmailAndPassword(email, password)
      .catch((err) => {
        switch (err.code) {
          case "auth/invalid-email":
          case "auth/user-disabled":
          case "auth/user-not-found":
            setEmailError(err.message);
            break;
          case "auth/wrong-password":
            setPasswordError(err.message);
            break;
        }
      });
  }
  function handleSignUp() {
    clearErrors();
    fire
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .catch((err) => {
        switch (err.code) {
          case "auth/email-already-in-use":
          case "auth/invalid-email":
            setEmailError(err.message);
            break;
          case "auth/weak-password":
            setPasswordError(err.message);
            break;
        }
      });
  }
  function handleLogout() {
    fire.auth().signOut();
  }
  function authListener() {
    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        setUser(user);
      } else {
        setUser("");
      }
    });
  }

  useEffect(() => {
    authListener();
  }, []);
  function handleClick() {
    history.push("/");
  }
  const classes = useStyles();
  return (
    <div>
      <div>
        {user ? (
          setTimeout(() => {
            history.push("/");
          }, 1000)
        ) : (
          <div className={classes.loginPage}>
            <LoginTable
              email={email}
              setEmail={setEmail}
              password={password}
              setPassword={setPassword}
              handleLogin={handleLogin}
              handleSignUp={handleSignUp}
              hasAccount={hasAccount}
              setHasAccount={setHasAccount}
              emailError={emailError}
              passwordError={passwordError}
            />
          </div>
        )}
      </div>
    </div>
  );
}
